import translationEN from '../locales/translation_en.json';
import translationTH from '../locales/translation_th.json';
import { createI18n } from 'vue-i18n'
import { getLocalStorage } from './functions/localStorage';
import { LOCAL_STORAGE } from './constants/localStorage';
import { DATA } from './constants/data';

export default defineNuxtPlugin((nuxtApp) => {

  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: getLocalStorage(LOCAL_STORAGE.BOILER_PLATE_LANGUAGE) || DATA.LANGUAGE.EN,
    messages: {
      en: translationEN,
      th: translationTH,
    }
  })

  nuxtApp.vueApp.use(i18n);
  return {
    provide: {
      i18n
    }
  }
})